var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tab-news',{attrs:{"councillor":_vm.councillor,"partyColor":_vm.partyColor,"likedArticles":_vm.likedArticles,"pinnedArticles":_vm.pinnedArticles,"articles":_vm.articles,"pageCount":_vm.pageCount,"loading":_vm.loading},on:{"fetchArticles":_vm.fetchArticles,"pinned":(type, reference, color) => _vm.$emit('pinned', type, reference, color)}})
}
var staticRenderFns = []

export { render, staticRenderFns }